<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Trading Spaces</h1>
<h1 class="bk1">The Colonial Marketplace and the Foundations of American Capitalism</h1>
<p class="bkau">Emma Hart</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">AND</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hart-0004.vue?79270d4f